module.exports = __webpack_public_path__ + "img/personalize-categories.eebfb412.png";